import React from "react";
import ParseAnswer from "../../../../../../AI_Search/AI_Search/Results/Message/Answer/ParseAnswer/ParseAnswer";

function Answer({
  answer,
  onIsolationMarkupChange,
  onSelectedIsolationMarkupChange,
}) {
  return (
    <ParseAnswer
      answer={answer}
      onIsolationMarkupChange={onIsolationMarkupChange}
      onSelectedIsolationMarkupChange={onSelectedIsolationMarkupChange}
    />
  );
}

export default Answer;
